<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import theme from '@/theme';
import moment from 'moment';

export default {
  name: 'NewsFavourabilityChart',

  props: {
    lines: {
      type: Object,
      required: true,
    },
    height: {
      type: [Number, String],
      default: 300,
    },
    showMonths: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chartOptions() {
      const ctx = this;

      return {
        chart: {
          height: this.height,
          type: 'line',
          plotBorderWidth: 0,
          spacingRight: 1,
          spacingBottom: 1,
          spacingLeft: 0,
          style: {
            fontFamily: "'Graphik Web', sans-serif",
          },
        },

        colors: [theme['bhpChartOrange'], theme['bhpChartYellow'], theme['bhpChartGreen']],

        credits: {
          enabled: false,
        },

        title: {
          text: '',
        },

        xAxis: {
          type: 'datetime',
          gridLineWidth: 1,
          labels: {
            format: ctx.showMonths ? '{value: %b %y}' : '{value:%Y}',
          },
        },

        yAxis: {
          gridLineWidth: 1,
          labels: {
            format: '{value}%',
          },
          title: null,
        },

        legend: {
          align: 'right',
          padding: 20,
          itemStyle: {
            fontWeight: 'normal',
          },
        },

        series: ctx.createSeriesData(),

        tooltip: {
          useHTML: true,
          formatter() {
            return ctx.showMonths
              ? `${new Date(this.x).toLocaleString('default', {
                  month: 'short',
                })} ${new Date(this.x).getFullYear()}<div>${this.series.name}: <strong>${
                  Math.round(this.y * 100) / 100
                }%</strong></div>`
              : `${new Date(this.x).getFullYear()}<div>${this.series.name}: <strong>${
                  Math.round(this.y * 100) / 100
                }%</strong></div>`;
          },
        },
      };
    },
  },

  methods: {
    createSeriesData() {
      const result = [];
      Object.keys(this.lines).forEach((key) => {
        result.push({
          name: key,
          type: 'spline',
          data: this.lines[key].map((point) => [moment(point[0], 'YYYY-MM').valueOf(), point[1]]),
        });
      });

      return result;
    },
  },
};
</script>
